import _ from 'lodash'

import { createAction } from 'redux-actions'
import { actionCreators as api } from 'reduxBits/api'

const prefix = 'Config:'
export const SET_ERROR = `${prefix} Set error.`
export const SET_BASE_URL = `${prefix} Set base URL from environment.`
export const SET_IKEA_BASE_URL = `${prefix} Set base Ikea URL`
export const SET_TRUST_API_URL = `${prefix} Set trust api URL`
export const SET_GLIMR_API_URL = `${prefix} Set glimr api URL`
export const SET_TRUST_WIDGET_URL = `${prefix} Set trust widget URL`
export const SET_API_URL = `${prefix} Set api url.`
export const SET_BETA_URL = `${prefix} Set beta url.`
export const SET_OLD_MOBILE_URL = `${prefix} Set old mobile url.`
export const SET_DESKTOP_URL = `${prefix} Set the desktop url.`
export const SET_SPID_URL = `${prefix} Set SPID url.`
export const SET_TEALIUM_CONFIG = `${prefix} Set tealium configuration.`
export const SET_SENTRY_DSN = `${prefix} Set sentry token.`
export const SET_SENTRY_ENVIRONMENT = `${prefix} Set sentry environment.`
export const SET_SPID_CLIENT_ID = `${prefix} Set Spid client id.`
export const SET_MESSAGE_CENTER_CONFIG = `${prefix} Set message center configuration.`
export const SET_CONTENTFUL_CONFIG = `${prefix} Set contentful configuration.`
export const SET_INITIAL_SIZE = `${prefix} Set initial size for @blazar-plugins/device`

export const SET_LOGIN_URL = `${prefix} Sets the blocket-login-helper login url`
export const SET_LOGOUT_URL = `${prefix} Sets the blocket-login-helper logout url`

const setError = createAction(SET_ERROR)
const setApiUrl = createAction(SET_API_URL)
const setSpidClientId = createAction(SET_SPID_CLIENT_ID)
const setBaseUrl = createAction(SET_BASE_URL)
const setSpidUrl = createAction(SET_SPID_URL)
const setIkeaBaseUrl = createAction(SET_IKEA_BASE_URL)
const setOldMobileBaseUrl = createAction(SET_OLD_MOBILE_URL)
const setDesktopUrl = createAction(SET_DESKTOP_URL)
const setTrustApiUrl = createAction(SET_TRUST_API_URL)
const setGlimrApiUrl = createAction(SET_GLIMR_API_URL)
const setTrustWidgetUrl = createAction(SET_TRUST_WIDGET_URL)

const setTealiumConfiguration = createAction(SET_TEALIUM_CONFIG)
const setSentryToken = createAction(SET_SENTRY_DSN)
const setSentryEnvironment = createAction(SET_SENTRY_ENVIRONMENT)
const setMessageCenterConfig = createAction(SET_MESSAGE_CENTER_CONFIG)
const setContentfulConfig = createAction(SET_CONTENTFUL_CONFIG)

const setLoginUrl = createAction(SET_LOGIN_URL)
const setLogoutUrl = createAction(SET_LOGOUT_URL)
const setInitialSize = createAction(SET_INITIAL_SIZE)

const fetchConfiguration = () => async (dispatch) => {
  const response = await dispatch(api.fetch('blocket/v6/configuration/chirp'))

  if (!response.ok) {
    dispatch(setError(true))
    return
  }

  const configuration = response.textOrJson

  dispatch(setError(false))
  dispatch(setSpidUrl(`${configuration.auth.spid.baseUrl}`))
  dispatch(setIkeaBaseUrl(`${configuration.common.baseUrl.ikeaExternalsite}`))
  dispatch(setOldMobileBaseUrl(`${configuration.common.baseUrlHttpsproxy.mobile}`))
  if (configuration.common.baseUrl.blocket) {
    dispatch(setDesktopUrl(configuration.common.baseUrl.blocket))
  }
  dispatch(setGlimrApiUrl(`${configuration.common.chirp.glimr.glimrUrl}`))
  dispatch(setTrustApiUrl(`${configuration.common.chirp.trust.apiUrl}`))
  dispatch(setTrustWidgetUrl(`${configuration.common.chirp.trust.widgetUrl}`))
  dispatch(setSpidClientId(configuration.auth.spid.clientId))
  dispatch(setMessageCenterConfig(_.get(configuration, 'common.messagecenter.webClient', {})))
  dispatch(setContentfulConfig(_.get(configuration, 'common.chirp.contentful', {})))
  dispatch(setBaseUrl(_.get(configuration, 'common.baseUrl.beta')))
  dispatch(setLoginUrl(_.get(configuration, 'common.blocketLoginHelper.loginUrl', '')))
  dispatch(setLogoutUrl(_.get(configuration, 'common.blocketLoginHelper.logoutUrl', '')))
  dispatch(
    setTealiumConfiguration({
      environment: process.env.TRACKING_ENV
        ? process.env.TRACKING_ENV
        : configuration.common.environment,
      ...configuration.common.tealium,
    }),
  )
}

export const actionCreators = {
  setSentryToken,
  setSentryEnvironment,
  setBaseUrl,
  fetchConfiguration,
  setApiUrl,
  setSpidUrl,
  setSpidClientId,
  setTealiumConfiguration,
  setContentfulConfig,
  setInitialSize,
}
